import { render } from "./SelectCompletedTraineesModal.vue?vue&type=template&id=260d0141&scoped=true"
import script from "./SelectCompletedTraineesModal.vue?vue&type=script&lang=js"
export * from "./SelectCompletedTraineesModal.vue?vue&type=script&lang=js"

import "./SelectCompletedTraineesModal.vue?vue&type=style&index=0&id=260d0141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260d0141"]])

export default __exports__